// extracted by mini-css-extract-plugin
module.exports = {"fileTypedIcon":"fileTypedIcon__Hl-69"};